import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Wrapper from '@bexs/dollar/components/Wrapper';
import ErrorBoundary from 'common/ErrorBoundary';
import store from 'store';
import GlobalStyle from 'styles/global';
import App from 'App';

ReactDOM.render(
  <>
    <ErrorBoundary>
      <Provider store={store}>
        <Wrapper>
          <App />
        </Wrapper>
      </Provider>
    </ErrorBoundary>
    <GlobalStyle />
  </>,
  document.getElementById('root')
);
